import { render, staticRenderFns } from "./UsingRecord.vue?vue&type=template&id=5ddba8bd&scoped=true&"
import script from "./UsingRecord.vue?vue&type=script&lang=js&"
export * from "./UsingRecord.vue?vue&type=script&lang=js&"
import style0 from "./UsingRecord.vue?vue&type=style&index=0&id=5ddba8bd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddba8bd",
  null
  
)

export default component.exports